import { stringify } from 'query-string';
import {
    fetchUtils,
    GET_LIST,
    GET_ONE,
    CREATE,
    UPDATE,
    UPDATE_MANY,
    DELETE,
    DELETE_MANY,
    GET_MANY,
    GET_MANY_REFERENCE,
} from 'react-admin';
import Cookies from 'universal-cookie';
import template from 'backtick-template'

import { resources_by_name, resources_map } from './resources.js'
import { envBaseURL, userCookieName } from '../AppConfig'
import getSafe from './util'
import { debug } from './pklog'

/**
 * Maps react-admin queries to the default format of Django REST Framework
 */
const drfProvider = (apiUrl, httpClient=fetchUtils.fetchJson) => {

     /**
      * @param {String} type One of the constants appearing at the top if this file, e.g. 'UPDATE'
      * @param {String} resource Name of the resource to fetch, e.g. 'posts'
      * @param {Object} params The REST request params, depending on the type
      * @returns {Object} { url, options } The HTTP request parameters
      */
     const convertDataRequestToHttp = (type, resource_gui, params) => {
         var API_URL = envBaseURL()
         const resource = resources_map[resource_gui] || resource_gui
         debug('convertRESTRequestToHTTP', type, resource, params)
         const isUserRel = getSafe(() => resources_by_name[resource].is_user_rel)
         const cookies = new Cookies();
         let FULL_API_URL = (isUserRel === true) ? API_URL+'/users/'+cookies.get(userCookieName) : API_URL;
         let url = '';
         let customUrl = '';
         const options = {
            credentials: 'include', // <= that's what changed
            method: "GET",
            mode: "cors"
         };
         options.headers = new Headers({
           Accept: 'application/json',
           "Content-Type": 'application/json; charset=utf-8'
         });
         switch (type) {
         case GET_LIST: {
            console.log('GET_LIST')
             customUrl = getSafe(() => resources_by_name[resource_gui].get_list.custom_url)
             const caseIsUserRel = getSafe(() => resources_by_name[resource_gui].get_list.is_user_rel)
             FULL_API_URL = (isUserRel !== true && caseIsUserRel === true) ? API_URL+'/users/'+cookies.get(userCookieName) : FULL_API_URL;

             const { page, perPage } = params.pagination;
             const { field, order } = params.sort;
             var filter = {};
             const search_ops = getSafe(() => resources_by_name[resource_gui].get_list.search_ops)
             for (var key in params.filter) {
               var value = params.filter[key]
               if (value.startsWith('"')) {
                 var v = value.slice(1)
                 if(v.endsWith('"')){
                   v = v.slice(0,-1)
                 }
                 filter[key] = v
               }
               else if(value.startsWith('~')) {
                 filter[key] = {'in':params.filter[key].slice(1)}
               }
               else if(value.startsWith('>')) {
                 filter[key] = {'gt':params.filter[key].slice(1)}
               }
               else if(value.startsWith('<')) {
                 filter[key] = {'lt':params.filter[key].slice(1)}
               }
               else if(value.startsWith('>=')) {
                 filter[key] = {'ge':params.filter[key].slice(2)}
               }
               else if(value.startsWith('<=')) {
                 filter[key] = {'le':params.filter[key].slice(2)}
               }
               else {
                 const op = search_ops ? search_ops[key] : undefined
                 console.log("SEARCH OP", op)
                 if(op) {
                   filter[key] = {[op]:params.filter[key]}
                 } else {
                   filter[key] = params.filter[key]
                 }
               }
               console.log("filter",filter)
             }
             const query = {
                 "sys.orderbyjson": JSON.stringify([field, order]),
                 "sys.range": JSON.stringify([(page - 1) * perPage, page * perPage]),
                 "sys.filter": JSON.stringify({"None": filter}),
             };
             const pagination = getSafe(() => resources_by_name[resource_gui].get_one.custom_url, true)
             if(pagination)
                 query["sys.range"] = JSON.stringify([(page - 1) * perPage, page * perPage - 1])
             else
                 query["sys.seek"] = JSON.stringify([page, perPage]) // in this case page should be the last id on the current page
             if(customUrl) {
                 url = template(customUrl, {FULL_API_URL, resource, query: stringify(query)})
                 url = url.indexOf('?') !== -1 ? `${url}` : `${url}?${stringify(query)}`
             }
             else {
                 url = `${FULL_API_URL}/${resource}?${stringify(query)}`;
             }
             break;
         }
         case GET_ONE:
             customUrl = getSafe(() => resources_by_name[resource_gui].get_one.custom_url)
             const getOneIsUserRel = getSafe(() => resources_by_name[resource_gui].get_one.is_user_rel)
             FULL_API_URL = (isUserRel !== true && getOneIsUserRel === true) ? API_URL+'/users/'+cookies.get(userCookieName) : FULL_API_URL;
             if(customUrl) {
                 url = template(customUrl, {FULL_API_URL, resource, id: params.id})
             } else {
                 url = `${FULL_API_URL}/${resource}/${params.id}`;
             }
             break;
         case GET_MANY: {
             const query = {
                 "sys.filter": JSON.stringify({ id: params.ids }),
             };
             url = `${FULL_API_URL}/${resource}?${stringify(query)}`;
             break;
         }
         case GET_MANY_REFERENCE: {
             const { page, perPage } = params.pagination;
             const { field, order } = params.sort;
             const query = {
                 "sys.orderbyjson": JSON.stringify([field, order]),
                 "sys.range": JSON.stringify([(page - 1) * perPage, (page * perPage) - 1]),
                 "sys.filter": JSON.stringify({"None":{ ...params.filter, [params.target]: params.id }}),
             };
             url = `${FULL_API_URL}/${resource}?${stringify(query)}`;
             break;
         }
         case UPDATE:
             const updateIsUserRel = getSafe(() => resources_by_name[resource_gui].edit.is_user_rel)
             FULL_API_URL = (isUserRel !== true && updateIsUserRel === true) ? API_URL+'/users/'+cookies.get(userCookieName) : FULL_API_URL;
             customUrl = getSafe(() => resources_by_name[resource_gui].edit.custom_url)
             const customMethod = getSafe(() => resources_by_name[resource_gui].edit.custom_method)
             const customKey = getSafe(() => resources_by_name[resource_gui].edit.custom_key)

             if(customUrl) {
                 url = template(customUrl, {FULL_API_URL, resource, id: params.id})
             }
             else {
               url = `${FULL_API_URL}/${resource}/${params.id}`;
             }

             if (customMethod) {
               options.method = customMethod
             } else {
               options.method = 'PUT'
             }

             if (customKey) {
               options.body = JSON.stringify(params.data[customKey])
             } else {
               options.body = JSON.stringify(params.data);
             }
             break;
         case CREATE:
             const caseIsUserRel = getSafe(() => resources_by_name[resource_gui].create.is_user_rel)
             FULL_API_URL = (isUserRel !== true && caseIsUserRel === true) ? API_URL+'/users/'+cookies.get(userCookieName) : FULL_API_URL;
             const isCreateRel = getSafe(() => resources_by_name[resource_gui].is_create_rel)
             customUrl = getSafe(() => resources_by_name[resource_gui].create.custom_url)
             if(customUrl) {
                 url = template(customUrl, {FULL_API_URL, resource})
             } else if(isCreateRel === true) {
                 url = `${FULL_API_URL}/${resource}/create_rel`
             } else {
                 url = `${FULL_API_URL}/${resource}`
             }
             options.method = 'POST';
             options.body = JSON.stringify(params.data);
             break;
         case DELETE:
             const deleteIsUserRel = getSafe(() => resources_by_name[resource_gui].delete.is_user_rel)
             FULL_API_URL = (isUserRel !== true && deleteIsUserRel === true) ? API_URL+'/users/'+cookies.get(userCookieName) : FULL_API_URL;
             url = `${FULL_API_URL}/${resource}/${params.id}`;
             options.method = 'DELETE';
             break;
         default:
             throw new Error(`Unsupported fetch action type ${type}`);
         }
         console.debug("url", url)
         console.debug("options", options)
         return { url, options };
     };

     /**
      * @param {Object} response HTTP response from fetch()
      * @param {String} type One of the constants appearing at the top if this file, e.g. 'UPDATE'
      * @param {String} resource Name of the resource to fetch, e.g. 'posts'
      * @param {Object} params The REST request params, depending on the type
      * @returns {Object} REST response
      */
     const convertHttpResponse = (response, type, resource, params) => {
         const { json } = response; //{ headers, json } = response;
         switch (type) {
         case GET_LIST:
           var listresult = {
               data: json.data.map(x => x),
               total: json.total_count //parseInt(headers.get('content-range').split('/').pop(), 10),
           }
           return listresult
         case CREATE:
             var createresult = { data: { ...params.data, id: json.id } };
             return createresult;
         default:
             var result = { data: (json) ? json : {...params.data} };
             return result;
         }
     };

    /**
     * @param {String} type React-admin request type, e.g. 'GET_LIST'
     * @param {string} resource Name of the resource to fetch, e.g. 'posts'
     * @param {Object} params Request parameters. Depends on the request type
     * @returns {Promise} the Promise for a data response
     */
    return (type, resource, params) => {
        /**
         * Split GET_MANY, UPDATE_MANY and DELETE_MANY requests into multiple promises,
         * since they're not supported by default.
         */
        switch (type) {
            case GET_MANY:
                return Promise.all(
                    params.ids.map(function(id) {
                      const {url, options} = convertDataRequestToHttp(GET_ONE, resource, {id: id} )
                      return httpClient(
                        url, options
                        // `${apiUrl}/${resource}/${id}/`,
                        // {
                        //     method: 'GET'
                        // }
                      )
                    }
                    )
                ).then(responses => {
                  return {
                    data: responses.map(response => response.json),
                  }
                }
                );
            case UPDATE_MANY:
                return Promise.all(
                    params.ids.map(id =>
                        httpClient(`${apiUrl}/${resource}/${id}`, {
                            method: 'PUT',
                            body: JSON.stringify(params.data),
                        })
                    )
                ).then(responses => ({
                    data: responses.map(response => response.json),
                }));
            case DELETE_MANY:
                return Promise.all(
                    params.ids.map(function(id){
                      const {url, options} = convertDataRequestToHttp(DELETE, resource, {id: id} )
                      return httpClient(url, options)
                    }
                )).then(responses => ({
                    data: [],
                }));
            default:
                break;
        }

        const { url, options } = convertDataRequestToHttp(type, resource, params);
        return httpClient(url, options)
            .then(response => convertHttpResponse(response, type, resource, params))
            .catch(function(error) {
              const error_text = getSafe(() => error.body.error) // error.status, error.body, error.error, error.stack
              if(error_text)
                throw Error(error_text)
              else
                throw error
            });
    }
}

export default drfProvider;
